export default __webpack_public_path__ + "static/media/radial.4ce24b68.svg";